import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { type ComponentProps } from 'react';

import { CHANNEL_ID_PAID_SEARCH } from '@/constants/channel';

import AdNameMultiSelect from './AdNameMultiSelect';

const KeywordNameMultiSelect = ({ ...rest }: ComponentProps<typeof AdNameMultiSelect>) => {
  return (
    <AdNameMultiSelect
      {...rest}
      channelId={CHANNEL_ID_PAID_SEARCH}
      placeholder={t`Select Keywords...`}
      data-testid="keyword-multiselect"
      notFoundContent={<Trans>No keywords were found...</Trans>}
    />
  );
};

export default KeywordNameMultiSelect;
